module.exports = __webpack_public_path__ + "img/thumb_17.a3dc9f6e.jpg";